import pb from '../lib/pocketbase';

export async function getCotizaDets(cotizaCabId, page, perPage) {
  return await pb.collection('cotiza_det').getList(page, perPage, {
    filter: `cotiza_cab = "${cotizaCabId}"`,
    sort: 'created',
    $autoCancel: false,
    expand: 'producto' // Expandir información del producto
  });
}

export async function createCotizaDet(cotizaDet) {
  return await pb.collection('cotiza_det').create(cotizaDet);
}

export async function updateCotizaDet(id, cotizaDet) {
  return await pb.collection('cotiza_det').update(id, cotizaDet);
}

export async function deleteCotizaDet(id) {
  return await pb.collection('cotiza_det').delete(id);
}

export async function getCotizaDetById(id) {
  return await pb.collection('cotiza_det').getOne(id, {
    expand: 'producto,cotiza_cab'
  });
}

export async function deleteAllCotizaDetsByCotizaCab(cotizaCabId) {
  try {
    // Obtener todos los detalles de la cotización
    const dets = await pb.collection('cotiza_det').getList(1, 1000, {
      filter: `cotiza_cab = "${cotizaCabId}"`,
      fields: 'id'
    });
    
    // Eliminar cada detalle
    for (const det of dets.items) {
      await pb.collection('cotiza_det').delete(det.id);
    }
    
    return true;
  } catch (error) {
    console.error('Error deleting cotiza_det records:', error);
    throw error;
  }
}

export async function getCotizaDetsByProduct(productoId, page, perPage) {
  return await pb.collection('cotiza_det').getList(page, perPage, {
    filter: `producto = "${productoId}"`,
    sort: '-created',
    $autoCancel: false,
    expand: 'cotiza_cab,producto'
  });
}
